module.exports = __webpack_public_path__ + "img/10_36.82e785ea.png";